// src/lib/imageCompress.js — FASE 4 · compressão de fotos no client antes do upload.
// Resize p/ ~1600px (lado maior) + JPEG com qualidade decrescente até ~300KB.
// É o que segura o crescimento de storage por tenant (margem dos planos).
// Não-imagens (PDF, DWG, docs), GIF/SVG e imagens já pequenas passam intactas.
// Em qualquer erro, devolve o arquivo original (upload nunca quebra por causa daqui).

const COMPRESSIVEIS = new Set(['image/jpeg', 'image/png', 'image/webp']);

/** @param {File} file @returns {Promise<File>} */
export async function comprimirImagem(file, { maxDim = 1600, alvoKB = 300 } = {}) {
  try {
    if (!(file instanceof File) || !COMPRESSIVEIS.has(file.type)) return file;
    if (file.size <= alvoKB * 1024) return file;

    let bmp;
    try { bmp = await createImageBitmap(file, { imageOrientation: 'from-image' }); }
    catch (_) { bmp = await createImageBitmap(file); } // Safari antigo sem a option
    const scale = Math.min(1, maxDim / Math.max(bmp.width, bmp.height));
    const w = Math.max(1, Math.round(bmp.width * scale));
    const h = Math.max(1, Math.round(bmp.height * scale));
    const canvas = document.createElement('canvas');
    canvas.width = w; canvas.height = h;
    canvas.getContext('2d').drawImage(bmp, 0, 0, w, h);
    if (bmp.close) bmp.close();

    let blob = null;
    for (const q of [0.72, 0.6, 0.5]) {
      blob = await new Promise((res) => canvas.toBlob(res, 'image/jpeg', q));
      if (blob && blob.size <= alvoKB * 1024) break;
    }
    if (!blob || blob.size >= file.size) return file; // não compensou
    const nome = (file.name || 'foto').replace(/\.\w+$/, '') + '.jpg';
    return new File([blob], nome, { type: 'image/jpeg', lastModified: Date.now() });
  } catch (e) {
    console.warn('[imageCompress] fallback original:', e?.message || e);
    return file;
  }
}
